import { render, staticRenderFns } from "./manifesto.vue?vue&type=template&id=4aa76d2a&"
import script from "./manifesto.vue?vue&type=script&lang=js&"
export * from "./manifesto.vue?vue&type=script&lang=js&"
import style0 from "./manifesto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports